import script from "./ServerConfigTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerConfigTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerConfigTab.vue?vue&type=style&index=0&id=066a4666&lang=scss"

const __exports__ = script;

export default __exports__